/**
 * depotManagers — Responsables de site (refonte dépôts 17/06/2026).
 *
 * Chaque dépôt (sauf le QG) DOIT avoir un responsable de site assigné pour
 * être opérationnel. Sans responsable, le dépôt ne peut recevoir aucun
 * camion ni servir aucun contrat (les transferts sont bloqués, les
 * couvertures de contrats invalidées).
 *
 * 10 profils diversifiés (FR + EU + Maroc), portraits générés via Nano
 * Banana (Gemini 3.1 Flash Image Preview) — cf.
 * /app/backend/scripts/generate_depot_managers.py.
 *
 * Tarification (€/mois employer cost incluant charges) :
 *   Senior expérimenté : 5 200 €
 *   Confirmé           : 4 200 €
 *   Junior dynamique   : 3 200 €
 */
export const DEPOT_MANAGERS = [
  {
    id: 'dmgr-claire-fontan',
    name: 'Claire Fontan',
    seniority: 'senior',
    monthlyCost: 5200,
    region: 'FR',
    bio: 'Quinze ans dans la grande distribution, spécialiste de la gestion de quai et des flux multimodaux. Calme, méthodique.',
    bonus: { type: 'throughput', value: 0.08, label: '+8 % efficacité de chargement' },
    portrait: '/depot-managers/dmgr-claire-fontan.webp',
    languages: ['fr', 'en'],
  },
  {
    id: 'dmgr-thierry-mendes',
    name: 'Thierry Mendes',
    seniority: 'senior',
    monthlyCost: 5200,
    region: 'FR',
    bio: 'Ancien chef d\'exploitation chez un transporteur national. Excellent négociateur et gestionnaire de crise.',
    bonus: { type: 'maintenance', value: 0.07, label: '−7 % maintenance véhicules' },
    portrait: '/depot-managers/dmgr-thierry-mendes.webp',
    languages: ['fr', 'pt'],
  },
  {
    id: 'dmgr-sofia-ribeiro',
    name: 'Sofia Ribeiro',
    seniority: 'confirmed',
    monthlyCost: 4200,
    region: 'EU',
    bio: 'Trilingue (FR/PT/ES), forte expérience péninsule ibérique. Idéale pour les dépôts Lisbonne, Porto, Madrid, Barcelone.',
    bonus: { type: 'iberic_revenue', value: 0.10, label: '+10 % CA contrats Ibérie' },
    portrait: '/depot-managers/dmgr-sofia-ribeiro.webp',
    languages: ['fr', 'pt', 'es'],
  },
  {
    id: 'dmgr-lukas-mueller',
    name: 'Lukas Müller',
    seniority: 'senior',
    monthlyCost: 5200,
    region: 'EU',
    bio: 'Ingénieur logistique allemand, formé chez DB Schenker. Excellence opérationnelle et reporting irréprochable.',
    bonus: { type: 'tier_revenue', value: 0.06, label: '+6 % CA contrats T4-T5' },
    portrait: '/depot-managers/dmgr-lukas-mueller.webp',
    languages: ['fr', 'en', 'de'],
  },
  {
    id: 'dmgr-giulia-rossi',
    name: 'Giulia Rossi',
    seniority: 'confirmed',
    monthlyCost: 4200,
    region: 'EU',
    bio: 'Italienne, ancienne responsable d\'agence Milan-Rome. Très bon réseau auprès des PME du nord italien.',
    bonus: { type: 'notoriety', value: 0.04, label: '+4 % notoriété locale' },
    portrait: '/depot-managers/dmgr-giulia-rossi.webp',
    languages: ['fr', 'en', 'it'],
  },
  {
    id: 'dmgr-mehdi-belhaj',
    name: 'Mehdi Belhaj',
    seniority: 'confirmed',
    monthlyCost: 4200,
    region: 'MA',
    bio: 'Casablancais, francophone parfait, spécialiste du corridor Maghreb-Europe. Excellent relationnel douanier.',
    bonus: { type: 'export_revenue', value: 0.12, label: '+12 % CA contrats Maroc/Export' },
    portrait: '/depot-managers/dmgr-mehdi-belhaj.webp',
    languages: ['fr', 'ar', 'en'],
  },
  {
    id: 'dmgr-james-okonkwo',
    name: 'James Okonkwo',
    seniority: 'senior',
    monthlyCost: 5200,
    region: 'UK',
    bio: 'Britannique, formé chez DHL UK. Maîtrise des formalités post-Brexit et des routes ferries Manche.',
    bonus: { type: 'uk_revenue', value: 0.10, label: '+10 % CA contrats UK' },
    portrait: '/depot-managers/dmgr-james-okonkwo.webp',
    languages: ['fr', 'en'],
  },
  {
    id: 'dmgr-anouk-vandersteen',
    name: 'Anouk Vandersteen',
    seniority: 'confirmed',
    monthlyCost: 4200,
    region: 'EU',
    bio: 'Néerlandaise basée Anvers, profil Benelux. Très orientée optimisation des coûts et tracking GPS.',
    bonus: { type: 'fuel', value: 0.05, label: '−5 % carburant véhicules du dépôt' },
    portrait: '/depot-managers/dmgr-anouk-vandersteen.svg',
    languages: ['fr', 'en', 'nl'],
  },
  {
    id: 'dmgr-julien-rocher',
    name: 'Julien Rocher',
    seniority: 'junior',
    monthlyCost: 3200,
    region: 'FR',
    bio: 'Jeune diplômé Bac+5 transport-logistique, dynamique et data-driven. Coût raisonnable mais courbe d\'apprentissage.',
    bonus: { type: 'support_cost', value: 0.10, label: 'Coût réduit, apprend vite' },
    portrait: '/depot-managers/dmgr-julien-rocher.webp',
    languages: ['fr', 'en'],
  },
  {
    id: 'dmgr-amal-rahmouni',
    name: 'Amal Rahmouni',
    seniority: 'confirmed',
    monthlyCost: 4200,
    region: 'FR',
    bio: 'Bilingue arabe-français, formée à l\'ISLI Bordeaux. Polyvalente, à l\'aise sur sites FR comme Maroc.',
    bonus: { type: 'flexibility', value: 0.05, label: '+5 % satisfaction équipe du dépôt' },
    portrait: '/depot-managers/dmgr-amal-rahmouni.webp',
    languages: ['fr', 'ar', 'en'],
  },
];

export const getDepotManagerById = (id) =>
  DEPOT_MANAGERS.find(m => m.id === id);

/**
 * Total mensuel des salaires des responsables de site recrutés (debited
 * monthly via coreSlice). Le QG n'a PAS de responsable (incarné par le
 * dirigeant joueur), seuls les dépôts non-QG en ont un.
 */
export function getTotalManagerCost(ownedDepots = []) {
  return (ownedDepots || []).reduce((sum, d) => {
    if (!d.managerId || d.isHeadquarters) return sum;
    const mgr = getDepotManagerById(d.managerId);
    return sum + (mgr?.monthlyCost || 0);
  }, 0);
}

/**
 * Un dépôt est OPÉRATIONNEL si :
 *   - c'est le QG (toujours opérationnel), OU
 *   - il a un managerId assigné dans state.depotManagers (recruté).
 *
 * Si non opérationnel : pas d'assignation de camion, pas de service de
 * contrat (le réseau ignore ce dépôt côté couverture géographique).
 */
export function isDepotOperational(depot, hiredDepotManagers = {}) {
  if (!depot) return false;
  if (depot.isHeadquarters) return true;
  if (!depot.managerId) return false;
  return !!hiredDepotManagers[depot.managerId];
}
